export const PREFERRED_PERSISTENCE_LOCAL_STORAGE_KEY_NAME =
  "2025-08-preferred-persistence-for-auth";
